/* eslint-disable react/display-name */
import React from "react";
import PropTypes from "prop-types";

import { Pill } from "@lululemon/ui-library";
import { closeIcon } from "@lululemon/ui-icons";

import { trackEvent } from "@lululemon/ecom-common/src/lib/analytics";
import { log } from "@lululemon/mwa-utils";

import LinkGenerator from "@lululemon/ecom-common/src/lib/link-generator";

// CONTEXT PROVIDER FOR SERP AND CDP
import useParseContext from "../../hooks/useParseContext";

import styles from "./filter-pills.module.scss";

const FilterPills = React.memo(({ pillData, pillRef }) => {
  const { handlePartialLoading, isSERP, isTabletOrBelow } = useParseContext();
  try {
    if (!pillData || (!isSERP && !isTabletOrBelow)) return null;
    return (
      <div className={styles.productFilterTags}>
        <h2 className="sr-only">Filters</h2>
        <ul ref={pillRef}>
          {pillData?.map((pill) => {
            const displayName = pill.label || null;
            const removeURL =
              pill?.removeAction?.navigationState ||
              pill?.["remove-action"]?.["navigation-state"] ||
              "";
            const contentPath =
              pill?.removeAction?.contentPath ||
              pill?.["remove-action"]?.["content-path"] ||
              "";
            if (!displayName) return null;
            return (
              <li key={displayName} className={styles.tagItemContainer}>
                <LinkGenerator
                  aria-label={`${
                    displayName.split("|")[0]
                  }, Remove this filter`}
                  className="tag-item__link"
                  to={`${contentPath}${removeURL}`}
                  onClick={() => {
                    trackEvent("cdp-filter-pill-removed");
                    handlePartialLoading();
                  }}
                >
                  <Pill
                    icon={closeIcon}
                    kind="filter"
                    className={styles.tagItem}
                    tag="span"
                  >
                    {displayName.split("|")[0]}
                  </Pill>
                </LinkGenerator>
              </li>
            );
          })}
        </ul>
      </div>
    );
  } catch (e) {
    log.error("Error Rendering FilterPills", e);
    return null;
  }
});

FilterPills.propTypes = {
  pillData: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  pillRef: PropTypes.oneOfType([
    PropTypes.func,
    // eslint-disable-next-line react/forbid-prop-types
    PropTypes.shape({ current: PropTypes.any }),
  ]).isRequired,
};
export default FilterPills;
